(function ($) {
  Drupal.behaviors.productDetailHeroV2 = {
    attach: function (context, settings) {
      var $template = $('.detail_hero-v2'),
        $tabs = $('.product-collection-tabs', $template);

      $('.js-tabs-list', $tabs).trigger('add_current');
    }
  };
})(jQuery);
